import React from 'react';
import TableTop from "./TableTop";
import leftarrow from '../../../icons/leftarrow.png';
import rightarrow from '../../../icons/rightarrow.png';

const Table15 = () => (
    <>
        <TableTop />
        <div className="table-responsive tableFixHead">
            <table className="table table-bordered table-style">
                <thead>
                <tr>
                    <th rowSpan={4} scope="col">№</th>
                    <th rowSpan={4} scope="col">Hududlar nomi</th>
                    <th colSpan={4} scope="col">Sug’orish ishlariga olingan suv miqdori</th>
                    <th colSpan={12} scope="col">Sug’orilgan maydon, ming GA</th>
                    <th rowSpan={4} scope="col">Sug’orish ishlarida qatnashgan suvchilar soni</th>
                </tr>
                <tr>
                    <th colSpan={2} scope="col">1.10-20.03.20 y. mln.m3</th>
                    <th colSpan={2} scope="col">Kunlik suv sarfi m3/s.</th>
                    <th colSpan={2} scope="col">Jami sug’orish ishlari</th>
                    <th colSpan={4} scope="col">G’alla sug’orish</th>
                    <th colSpan={3} scope="col">Sho’r yuvish ming, GA</th>
                    <th colSpan={3} scope="col">Pushta va nam suv nerish ishlari</th>
                </tr>
                <tr>
                    <th rowSpan={2} scope="col">Limit</th>
                    <th rowSpan={2} scope="col">Amalda</th>
                    <th rowSpan={2} scope="col">Limit</th>
                    <th rowSpan={2} scope="col">Amalda</th>
                    <th rowSpan={2} scope="col">Reja</th>
                    <th rowSpan={2} scope="col">(1.10.2019 y. dan)</th>
                    <th rowSpan={2} scope="col">Reja</th>
                    <th rowSpan={2} scope="col">1 kunda</th>
                    <th rowSpan={2} scope="col">1 martdan boshlab</th>
                    <th rowSpan={2} scope="col">Jami ekilgandan boshlab</th>
                    <th rowSpan={2} scope="col">Reja</th>
                    <th rowSpan={2} scope="col">1 kunda</th>
                    <th rowSpan={2} scope="col">Jami</th>
                    <th rowSpan={2} scope="col">Reja</th>
                    <th colSpan={2} scope="col">Amalda</th>
                </tr>
                <tr>
                    <th scope="col">1 kunda</th>
                    <th scope="col">Jami</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th>1</th>
                    <th>Qoraqalpog’iston Respublikasi</th>
                    <td>1296</td>
                    <td>1296</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>2</th>
                    <th>      Andijon</th>
                    <td>1296</td>
                    <td>1296</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>3</th>
                    <th>      Buxoro</th>
                    <td>1296</td>
                    <td>1296</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>4</th>
                    <th>      Jizzax</th>
                    <td>1296</td>
                    <td>1296</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>5</th>
                    <th>      Qashqadaryo</th>
                    <td>1296</td>
                    <td>1296</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>6</th>
                    <th>      Navoiy</th>
                    <td>1296</td>
                    <td>1296</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>7</th>
                    <th>      Namangan</th>
                    <td>1296</td>
                    <td>1296</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>8</th>
                    <th>      Samarqand</th>
                    <td>1296</td>
                    <td>1296</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>9</th>
                    <th>Surxondaryo</th>
                    <td>1296</td>
                    <td>1296</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>10</th>
                    <th>      Sirdaryo</th>
                    <td>1296</td>
                    <td>1296</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>11</th>
                    <th>      Toshkent</th>
                    <td>1296</td>
                    <td>1296</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>12</th>
                    <th>      Farg’ona</th>
                    <td>1296</td>
                    <td>1296</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th>13</th>
                    <th>      Xorazm</th>
                    <td>1296</td>
                    <td>1296</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th></th>
                    <th>      Jami</th>
                    <td>1296</td>
                    <td>1296</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                <tr>
                    <th></th>
                    <th>2019 yilda</th>
                    <td>1296</td>
                    <td>1296</td>
                    <td>1296</td>
                    <td>53</td>
                    <td>0.4</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>63.6</td>
                    <td>53.0</td>
                    <td>0.4</td>
                    <td>9.8</td>
                    <td>2.0</td>
                    <td>880</td>
                    <td>2914</td>
                </tr>
                </tbody>
            </table>
        </div>
        <ul className="table-pagination">
            <li>Rows per page: 10</li>
            <li>1-10 of 276</li>
            <li><button><img src={leftarrow} alt="404"/></button></li>
            <li><button><img src={rightarrow} alt="404"/></button></li>
        </ul>
    </>
);
export default Table15;